module.exports = __webpack_public_path__ + "static/img/4.a253e7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carousel-1/4.jpg
// module id = 8gK8
// module chunks = 1